export function fmtBytes(b) {
  if (!b) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(b) / Math.log(k));
  return `${(b / Math.pow(k, i)).toFixed(i === 0 ? 0 : 1)} ${sizes[i]}`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export function fmtRelative(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 30) return `${Math.floor(diff / 86400)}d ago`;
  return fmtDate(iso);
}

/**
 * Feb 2026 R148j · Human-friendly absolute date-time.
 *   Example → "04-Aug-26 04:08:59 AM"
 * Used in thread / audit rows where operators need the exact instant
 * without hovering for the tooltip.
 */
export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return String(iso);
    const day = String(d.getDate()).padStart(2, "0");
    const mon = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][d.getMonth()];
    const yr = String(d.getFullYear()).slice(-2);
    let h = d.getHours();
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12; if (h === 0) h = 12;
    const hh = String(h).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    const ss = String(d.getSeconds()).padStart(2, "0");
    return `${day}-${mon}-${yr} ${hh}:${mm}:${ss} ${ampm}`;
  } catch { return String(iso); }
}

/**
 * Feb 2026 R148j · Combined absolute + relative view.
 *   "04-Aug-26 04:08:59 AM · 9d ago"
 */
export function fmtAbsRelative(iso) {
  if (!iso) return "—";
  const abs = fmtDateTime(iso);
  const rel = fmtRelative(iso);
  // Skip the relative half when it collapses to a raw date (already shown).
  if (rel === abs || rel === fmtDate(iso)) return abs;
  return `${abs} · ${rel}`;
}

export function fmtDuration(seconds) {
  if (seconds == null || isNaN(seconds)) return "—";
  const s = Math.max(0, Math.round(seconds));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${s % 60 ? `${s % 60}s` : ""}`.trim();
  const h = Math.floor(m / 60);
  if (h < 48) return `${h}h ${m % 60 ? `${m % 60}m` : ""}`.trim();
  return `${Math.floor(h / 24)}d ${h % 24}h`;
}

export function readFileAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

export function currencySymbol(code) {
  return { INR: "₹", USD: "$", EUR: "€", GBP: "£" }[code] || code;
}

export function fmtMoney(amount, currency) {
  if (amount == null) return "—";
  return `${currencySymbol(currency)}${Number(amount).toLocaleString()}`;
}
